import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = [".open"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = ["value", "checked"]
const _hoisted_4 = ["value", "checked"]
const _hoisted_5 = { slot: "footer" }
const _hoisted_6 = ["disabled"]

import { ref } from 'vue';
import { useStore } from 'vuex';
import Banner from '@components/Banner/Banner.vue';
import { useDeleteApplication } from '../../queries/useApplicationMutations';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDeleteModal',
  emits: ['deleted'],
  setup(__props, { expose: __expose }) {

const store = useStore() as any;
const t = store.getters['i18n/t'];

const {mutate: deleteApplication, isPending: isDeletingApplication, isError: deleteApplicationError, error: deleteApplicationErrorData} = useDeleteApplication(store, handleSuccess);

const showModal = ref(false);
const appToDelete = ref<any>(null);
const errors = ref<string[]>([]);
const deleteFromRegistry = ref(false);
const deletePVC = ref(false);

function openDelete(row: any) {
  appToDelete.value = row;
  errors.value = [];
  showModal.value = true;
}

function closeDelete() {
  showModal.value = false;
  deleteFromRegistry.value = false;
  deletePVC.value = false;
  errors.value = [];
  appToDelete.value = null;
}

async function onSubmitDelete() {
  if (!appToDelete.value) return;

    const appName = appToDelete.value.meta.name;
    const appNamespace = appToDelete.value.meta.namespace;
    deleteApplication({ namespace: appNamespace, app: appName, body: { deleteImage: deleteFromRegistry.value, deletePVC: deletePVC.value, unmounted: true } });
}

function handleSuccess() {
  store.dispatch('growl/success', {
    title:   t('epinio.growl.application.delete.success.title'),
    message: t('epinio.growl.application.delete.success.message', { name: appToDelete.value?.meta.name }),
  });
  closeDelete();
}

__expose({ openDelete });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-modal", {
    ".open": showModal.value,
    title: "Are you sure?",
    onModalClose: closeDelete
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[2] || (_cache[2] = _createTextVNode("You are attempting to delete the application ", -1)),
        _createElementVNode("strong", null, _toDisplayString(appToDelete.value?.meta?.name), 1),
        _cache[3] || (_cache[3] = _createTextVNode(".", -1))
      ]),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _createElementVNode("trailhand-checkbox", {
        value: deleteFromRegistry.value,
        checked: deleteFromRegistry.value,
        onCheckboxChange: _cache[0] || (_cache[0] = (e) => { deleteFromRegistry.value = e.detail.checked; })
      }, "Remove the application's container image from registry", 40, _hoisted_3),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createElementVNode("trailhand-checkbox", {
        value: deletePVC.value,
        checked: deletePVC.value,
        onCheckboxChange: _cache[1] || (_cache[1] = (e) => { deletePVC.value = e.detail.checked; })
      }, "Delete the application's persistent storage", 40, _hoisted_4),
      _cache[6] || (_cache[6] = _createTextVNode()),
      (_unref(deleteApplicationError))
        ? (_openBlock(), _createBlock(Banner, {
            key: 0,
            color: "error",
            label: _unref(deleteApplicationErrorData)?.message || _unref(t)('epinio.application.errors.delete')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("trailhand-button", {
        variant: "secondary",
        class: "mr-10",
        onButtonClick: closeDelete
      }, "\n        Cancel\n      ", 32),
      _cache[7] || (_cache[7] = _createTextVNode()),
      _createElementVNode("trailhand-button", {
        variant: "destructive",
        disabled: _unref(isDeletingApplication),
        onButtonClick: onSubmitDelete
      }, _toDisplayString(_unref(isDeletingApplication) ? _unref(t)('generic.deleting') : _unref(t)('generic.delete')), 41, _hoisted_6)
    ])
  ], 40, _hoisted_1))
}
}

})